/**
 * CUSTOMER-R4.6 — bank-neutral payment payload. Launchers derive from this only.
 */
import type { BankPaymentClientPayload } from "./bank-iban-payment-v2.js";
import { STORE_INFO } from "./store-merchant-sot-v2.js";

export type BankPaymentIntent = {
  public_order_number: string;
  amount_minor: number;
  currency: "UAH";
  recipient_name: string;
  recipient_tax_id: string;
  recipient_iban: string;
  recipient_bank_name: string;
  purpose: string;
  amount_uah: string;
  public_url: string;
  nbu_uri: string | null;
};

export function bankPaymentIntentFromClient(payload: BankPaymentClientPayload): BankPaymentIntent {
  return {
    public_order_number: payload.public_order_number,
    amount_minor: payload.amount_minor,
    currency: "UAH",
    recipient_name: payload.seller || STORE_INFO.merchantName,
    recipient_tax_id: payload.rnokpp || STORE_INFO.edrpou,
    recipient_iban: payload.iban || STORE_INFO.iban,
    recipient_bank_name: payload.bank || STORE_INFO.bank,
    purpose: payload.purpose,
    amount_uah: payload.amount_uah,
    public_url: payload.public_url,
    nbu_uri: payload.launch.uri,
  };
}
